const pageNameKey = "thingsOsHomepage";

export const thingsOsHomepageEn = {
  [pageNameKey]: {
    thingsSupportDescription: "Support for production and machine issues",
    thingsTwinsDescription: "Machine Twins and operational data",
    thingsGatewayDescription: " Things Gateways and machines",
    userManagementDescription: "Users, roles and permissions",
    thingsAIDescription: "Direct help with injection modeling questions",
    companyLogoAltText: "Company Logo",
  },
};

export const thingsOsHomepagePtBr = {
  [pageNameKey]: {
    thingsSupportDescription:
      "Suporte para problemas de produção e de máquinas",
    thingsTwinsDescription: "Gêmeos de máquinas e dados operacionais",
    thingsGatewayDescription: "Things, gateways e máquinas",
    userManagementDescription: "Usuários, funções e permissões",
    thingsAIDescription:
      "Ajuda direta com perguntas sobre modelagem de injeção",
    companyLogoAltText: "Logotipo da empresa",
  },
};

export const thingsOsHomepageDe = {
  [pageNameKey]: {
    thingsSupportDescription: "Support für Produktions- und Maschinenprobleme",
    thingsTwinsDescription: "Maschinen-Zwillinge und Betriebsdaten",
    thingsGatewayDescription: "Things Gateways und Maschinen",
    userManagementDescription: "Benutzer, Rollen und Berechtigungen",
    thingsAIDescription: "Direkte Hilfe bei Fragen zur Einspritzmodellierung",
    companyLogoAltText: "Unternehmenslogo",
  },
};

export const thingsOsHomepageZhHans = {
  [pageNameKey]: {
    thingsSupportDescription: "生产和机器问题支持",
    thingsTwinsDescription: "机器孪生和运行数据",
    thingsGatewayDescription: "Things 网关和机器",
    userManagementDescription: "用户、角色和权限",
    thingsAIDescription: "直接帮助解决注入建模问题",
    companyLogoAltText: "公司标志",
  },
};

export const thingsOsHomepageIt = {
  [pageNameKey]: {
    thingsSupportDescription:
      "Supporto per problemi di produzione e macchinari",
    thingsTwinsDescription: "Gemelli digitali e dati operativi",
    thingsGatewayDescription: "Things Gateway e macchine",
    userManagementDescription: "Utenti, ruoli e autorizzazioni",
    thingsAIDescription:
      "Assistenza diretta per domande sulla modellazione delle iniezioni",
    companyLogoAltText: "Logo aziendale",
  },
};

export const thingsOsHomepageEs = {
  [pageNameKey]: {
    thingsSupportDescription:
      "Soporte para problemas de producción y maquinaria",
    thingsTwinsDescription: "Gemelos de máquinas y datos operativos",
    thingsGatewayDescription: "Things, gateways y máquinas",
    userManagementDescription: "Usuarios, roles y permisos",
    thingsAIDescription:
      "Ayuda directa con preguntas sobre modelos de inyección",
    companyLogoAltText: "Logotipo de la empresa",
  },
};

export const thingsOsHomepageNl = {
  [pageNameKey]: {
    companyLogoAltText: "Bedrijfslogo",
    thingsAIDescription: "Directe hulp bij vragen over spuitgieten",
    thingsGatewayDescription: " Things-gateways en machines",
    thingsSupportDescription:
      "Ondersteuning voor productie- en machineproblemen",
    thingsTwinsDescription: "Machine-twins en operationele gegevens",
    userManagementDescription: "Gebruikers, rollen en rechten",
  },
};

export const thingsOsHomepageTr = {
  [pageNameKey]: {
    companyLogoAltText: "Şirket logosu",
    thingsAIDescription:
      "Enjeksiyon modelleme sorularıyla ilgili doğrudan yardım",
    thingsGatewayDescription: "Ağ geçitleri ve makineler",
    thingsSupportDescription: "Üretim ve makine konularında destek",
    thingsTwinsDescription: "Makine İkizleri ve operasyonel veriler",
    userManagementDescription: "Kullanıcılar, roller ve izinler",
  },
};
